import { render, staticRenderFns } from "./ManagerList.vue?vue&type=template&id=2a5341da&scoped=true"
import script from "./ManagerList.vue?vue&type=script&lang=ts"
export * from "./ManagerList.vue?vue&type=script&lang=ts"
import style0 from "./ManagerList.vue?vue&type=style&index=0&id=2a5341da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5341da",
  null
  
)

export default component.exports